import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { NgxImgZoomService } from 'ngx-img-zoom';
import { Category } from 'src/app/models/category/categoryListing.modal';
import { Order, ProductModel } from 'src/app/models/Home/home-list.model';
import { GetProductAssetModel, ProductWarrantyServiceItem, ProductWarrantyServiceModel } from 'src/app/models/product/productAssets.modal';
import { AlertifyService } from 'src/app/services/Common/alertify.service';
import { LocalstorageService } from 'src/app/services/Common/localstorage.service';
import { HomePageService } from 'src/app/services/home-page.service';
import { ProductService } from 'src/app/services/product.service';
import { SeoSettingService } from 'src/app/services/seo-setting.service';
import { AddProductWarrantyServiceComponent } from '../add-product-warranty-service/add-product-warranty-service.component';

@Component({
  selector: 'app-product-page',
  templateUrl: './product-page.component.html',
  styleUrls: ['./product-page.component.css']
})
export class ProductPageComponent implements OnInit {
  @Input('productId') ProductId: number;
  @Input('fileType') FileType: string = '1';
  @Input('fileChooseType') fileChooseType: string;

  productAssets: GetProductAssetModel = new GetProductAssetModel();
  productId: number;
  toggle: boolean = false;
  productImageResponseModel: Array<GetProductAssetModel> = new Array<GetProductAssetModel>();
  productDetail: ProductModel = new ProductModel();
  ShowImageinMainFrame: GetProductAssetModel = new GetProductAssetModel();
  ImageLoader: boolean = false;
  Loader: boolean = false;
  clickedIndex: number = 0;
  categoryResonseFullList: Array<Category> = new Array<Category>();
  categoryId: Category = new Category();
  enableZoom: Boolean = true;
  productbBuyNowModelVm: Array<Order> = new Array<Order>();
  productLoader: boolean = false;
  productName: string;
  imagePath: any;
  isFirstZoomTriggered: boolean = false;
  productWarrantyServiceModel: ProductWarrantyServiceModel = new ProductWarrantyServiceModel();
  productWarrantyServiceItem: ProductWarrantyServiceItem = new ProductWarrantyServiceItem;
  localStorageService: LocalstorageService;
  isQuote: boolean;

  constructor(private alertify: AlertifyService, private _localStorageService: LocalstorageService, private ngxImgZoom: NgxImgZoomService, private activatedRoute: ActivatedRoute, private productServiceId: ProductService, private homePageService: HomePageService, private router: Router, private modalService: NgbModal, private _seoSettingHeaderService: SeoSettingService) {
    this.ngxImgZoom.setZoomBreakPoints([{ w: 100, h: 100 }, { w: 150, h: 150 }, { w: 200, h: 200 }, { w: 250, h: 250 }, { w: 300, h: 300 }]);
    this.localStorageService = _localStorageService;
  }
  ngOnInit() {
    this.activatedRoute.params.subscribe((param) => {
      this.productId = +param.productId;
    });
    
    this.productAssets.FileType = this.FileType;
    this.FileType == this.fileChooseType;
    this.productMultipleImage(this.FileType);
    this.getProductAssetsContent();
    this.getWarrantyServiceProduct();
    localStorage.setItem('productId', this.productId.toString());
  }

  initZoom() {
    if (!this.isFirstZoomTriggered) {
      this.isFirstZoomTriggered = true;
      document.getElementById("myresult").style.backgroundSize = '540px 540px';
    }
  }

  productMultipleImage(FileType) {
    this.productAssets.ImageLoader = true;
    this.productAssets.ProductId = this.productId;
    this.productAssets.FileType = FileType;
    this.homePageService.GetProductMultipleImage(this.productAssets)
      .subscribe((response) => {
        let responseBody = JSON.parse(response._body)
        if (responseBody.isSuccess) {
          this.productAssets.ImageLoader = false;
          this.productImageResponseModel = responseBody.responseData;
          this.FileType = this.productImageResponseModel[0].type.toLocaleString();
          this.ShowImageinMainFrame = this.productImageResponseModel[0];
        }
      })
  }

  productBuyNow() {
    if (this.localStorageService.getToken()) {
      this.productAssets.ProductId = this.productId;
      this.router.navigate(['/order-confirm/' + this.productAssets.ProductId]);
    } else {
      this.router.navigate(['/login'], { queryParams: { return: window.location.href } });
    }
  }

  getProductAssetsContent() {
    this.Loader = true;
    this.productAssets.ProductId = this.productId;
    this.homePageService.GetProductDetail(this.productAssets)
      .subscribe((response) => {
        let responseBody = JSON.parse(response._body)
        if (responseBody.isSuccess) {
          this.productDetail = responseBody.responseData;
          this._seoSettingHeaderService.setTitle(responseBody.responseData.productTitle);
          this._seoSettingHeaderService.setDescription(responseBody.responseData.seoDescription);
          this._seoSettingHeaderService.setKeyword(responseBody.responseData.seoKeyword);
          this.isQuote = this.productDetail.isQuote;
          setTimeout(() => {
            this.showDescriptionEditorValue();
            this.showFeatureEditorValue();
          }, 100);
          this.Loader = false;
        } (err) => {
          this.Loader = false;
        }
      })
  }

  getWarrantyServiceProduct() {
    this.productWarrantyServiceModel.ProductId = this.productId
    this.homePageService.GetProductWarrantyServiceList(this.productWarrantyServiceModel)
      .subscribe((response) => {
        var responseBody = JSON.parse(response._body);
        if (responseBody.isSuccess) {
          this.productWarrantyServiceItem.ProductWarrantyList = responseBody.responseData
        }
      })
  };

  productWarrantyService(productWarrantyDetail) {
    localStorage.setItem("WarrantyId", productWarrantyDetail.warrantyId);
    var modalConfig = new NgbModalConfig();
    modalConfig.size = "lg";
    modalConfig.centered = true;
    modalConfig.backdrop = false;
    modalConfig.keyboard = false;
    this.homePageService.passId(productWarrantyDetail.warrantyId);
    let modalRef = this.modalService.open(AddProductWarrantyServiceComponent, modalConfig);
    modalRef.componentInstance.isQuote = this.isQuote;
  }

  showFeatureEditorValue() {
    var featureElement: HTMLIFrameElement = document.getElementById('features') as HTMLIFrameElement;
    featureElement.innerHTML = this.productDetail.features;
  }

  showDescriptionEditorValue() {
    var descriptionElement: HTMLIFrameElement = document.getElementById('description') as HTMLIFrameElement;
    descriptionElement.innerHTML = this.productDetail.description;
  }

  showDocuments(FileType) {
    this.toggle = !this.toggle;
    this.productMultipleImage(FileType)

  }

  requestQuote() {
      if (this.localStorageService.getToken()) {
        this.productAssets.ProductId = this.productId;
        this.router.navigate(['/request-quote/' + this.productAssets.ProductId]);
      } else {
        this.router.navigate(['/login'], { queryParams: { return: window.location.href } });
      }
  }
  
  shopNow() {
    this.router.navigate(['/home-page']);
  }
}
